/**
 * PauseGuideCard — 1회차 책 안내 카드.
 * 영상 아래 문제 풀이 확인 안내.
 * Spec §7.2
 */
import { BookOpen } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import type { MaterialNotice } from '@/api/lcLearning'
import { Button } from '../ui/Button'

interface Props {
  pointIndex: number
  materialNotice?: MaterialNotice | null
  submitting?: boolean
  onConfirmGuide: () => void
}

export default function PauseGuideCard({
  pointIndex,
  materialNotice,
  submitting = false,
  onConfirmGuide,
}: Props) {
  const { t } = useTranslation('learner')
  const materialLabel = materialNotice?.title ?? t('pause.guideMaterialFallback')
  const page = materialNotice?.blockQuizStartPage
  return (
    <div className="flex min-h-20 w-full flex-col gap-4 rounded-2xl bg-lc-bg-primary p-5 shadow-[0_4px_4px_rgba(0,0,0,0.05)] sm:flex-row sm:items-center">
      <div className="flex min-w-0 flex-1 items-center gap-5">
        <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-lc-key-50 text-lc-key-500">
          <BookOpen className="size-6" aria-hidden />
        </div>
        <div className="min-w-0 flex-1">
          <p className="truncate text-lc-v3-label-md font-semibold text-lc-v3-gray-600">
            {materialLabel}
          </p>
          <p className="text-lc-v3-body-1 font-bold text-lc-text-primary">
            {page != null
              ? t('pause.guideBodyWithPage', { page, n: pointIndex + 1 })
              : t('pause.guideBody', { n: pointIndex + 1 })}
          </p>
        </div>
      </div>
      <div className="flex shrink-0 items-center justify-end gap-3">
        <Button variant="primary" size="L" disabled={submitting} onClick={onConfirmGuide}>
          {t(submitting ? 'pause.submitting' : 'pause.confirmGuide')}
        </Button>
      </div>
    </div>
  )
}
